import { createContext } from 'react';

const IndexContext = /*#__PURE__*/createContext(undefined);
const IndexSelectionChangeContext = /*#__PURE__*/createContext(undefined);
const IndexRowContext = /*#__PURE__*/createContext(undefined);

export { IndexContext, IndexRowContext, IndexSelectionChangeContext };
